import React from 'react';
import { PawPrint } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console for development
    console.error('Error caught by boundary:', error, errorInfo);
    
    // You could also log the error to an error reporting service here
    this.setState({
      error,
      errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      // Custom fallback UI
      return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-900 to-gray-800">
          <div className="max-w-md w-full mx-auto p-8">
            <div className="bg-gray-800 border border-red-500 rounded-lg p-6 text-center">
              <div className="flex justify-center mb-4">
                <PawPrint className="w-16 h-16 text-[#b2f141]" />
              </div>
              <h1 className="text-2xl font-bold text-white mb-4">
                Oops! Something went wrong
              </h1>
              <p className="text-gray-300 mb-6">
                We're sorry, but something unexpected happened. Please try refreshing the page.
              </p>
              <button
                onClick={() => window.location.reload()}
                className="bg-[#b2f141] hover:bg-[#9fd82f] text-gray-900 py-3 px-6 rounded-lg font-bold transition-colors"
              >
                Refresh Page
              </button>
              
              {process.env.NODE_ENV === 'development' && this.state.error && (
                <details className="mt-6 text-left">
                  <summary className="text-sm text-gray-400 cursor-pointer hover:text-gray-300">
                    Error Details (Development Only)
                  </summary>
                  <div className="mt-4 p-4 bg-gray-900 rounded text-xs text-red-400 overflow-auto max-h-64">
                    <p className="font-bold mb-2">{this.state.error.toString()}</p>
                    <pre className="text-gray-500 whitespace-pre-wrap">
                      {this.state.errorInfo?.componentStack}
                    </pre>
                  </div>
                </details>
              )}
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;


